
export class ColorService {
    static darkenHexColor(hex: string, percent = 0.3): string {
        hex = hex.replace(/^#/, "");
        if (hex.length === 3) {
            hex = hex.split("").map(x => x + x).join("");
        }
        const r = Math.round(parseInt(hex.substring(0,2), 16) * (1 - percent));
        const g = Math.round(parseInt(hex.substring(2,4), 16) * (1 - percent));
        const b = Math.round(parseInt(hex.substring(4,6), 16) * (1 - percent));
        return "#" + [r, g, b].map(x => x.toString(16).padStart(2, "0")).join("");
    }

    static lightenHexColor(hex: string, percent = 0.3): string {
        hex = hex.replace(/^#/, "");
        if (hex.length === 3) {
            hex = hex.split("").map(x => x + x).join("");
        }
        const r = Math.round(parseInt(hex.substring(0,2), 16) + (255 - parseInt(hex.substring(0,2), 16)) * percent);
        const g = Math.round(parseInt(hex.substring(2,4), 16) + (255 - parseInt(hex.substring(2,4), 16)) * percent);
        const b = Math.round(parseInt(hex.substring(4,6), 16) + (255 - parseInt(hex.substring(4,6), 16)) * percent);
        return "#" + [r, g, b].map(x => x.toString(16).padStart(2, "0")).join("");
    }

    static opacityHexColor(hex: string, opacity: number): string {
        // opacity: 0 (transparent) to 1 (opaque)
        hex = hex.replace(/^#/, "");
        if (hex.length === 3) {
            hex = hex.split("").map(x => x + x).join("");
        }
        const alpha = Math.round(opacity * 255);
        const alphaHex = alpha.toString(16).padStart(2, "0");
        return `#${hex}${alphaHex}`;
    }
}
